import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "./useAuth";

export default function ProtectedRoutes() {
  const token = useAuth();

  return token ? <Outlet /> : <Navigate to="/login" />;
}
